import { partial } from "lodash";
import { useQuery } from "@tanstack/react-query";
import { useParams, useRouteMatch } from "react-router-dom";
import { EventEditCompletedPage } from "./EventEditCompletedPage";
import { Routes } from "@greeter-venue/utility/Routes";
import { useGreeterVenueApi } from "@greeter/matter";

type Params = {
  id: string;
};

export function EditEventCompletedApiHandler() {
  const routeMatch = useRouteMatch<Params>(
    Routes.mainGroup.editEvent.template()
  );
  const id = routeMatch?.params.id;

  const { api: venueApi } = useGreeterVenueApi();
  const { fetchGreeterEvent } = venueApi;

  const greeterEventQuery = useQuery({
    queryKey: ["greeterEvent", id],
    queryFn: partial(fetchGreeterEvent.bind(venueApi), id ?? ""),
    refetchOnWindowFocus: false,
    enabled: !!id,
  });

  return greeterEventQuery.data ? (
    <EventEditCompletedPage
      greeterEvent={
        greeterEventQuery.isLoading ? "loading" : greeterEventQuery.data
      }
    />
  ) : (
    <></>
  );
}
